import React, { useEffect, useLayoutEffect } from 'react';
import './portfolio.css';
import martin1 from '../Images/martin1.png';
import martin2 from '../Images/martin2.png';
import martin3 from '../Images/martin3.png';
import Banner from '../Marque/Scroller';
import Footer from '../Footer/Footer';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


function Portfolio() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const animation = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])
    const animation2 = useAnimation();
    const [featuredRef2, inView2] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView2) {
            animation2.start("visible")
        }
    }, [animation2, inView2])

    const animation3 = useAnimation();
    const [featuredRef3, inView3] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView3) {
            animation3.start("visible")
        }
    }, [animation3, inView3])
    const animation4 = useAnimation();
    const [featuredRef4, inView4] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView4) {
            animation4.start("visible")
        }
    }, [animation4, inView4])
    const animation5 = useAnimation();
    const [featuredRef5, inView5] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView5) {
            animation5.start("visible")
        }
    }, [animation5, inView5])
    const animation6 = useAnimation();
    const [featuredRef6, inView6] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView6) {
            animation6.start("visible")
        }
    }, [animation6, inView6])
    const transition = {duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]};
    return (
        // Martin Building Company is renowned for our commitment to quality design, historic preservation and neighborhood-oriented urban infill development. We craft an intriguing blend of stunning contemporary architecture and civic responsibility into all our projects 
        <>
        <div className="portfolio">
            <div className="portfolio__div1">
                <div className="portfolio__div4">
                <div className="portfolio__div2">
                    <h2>2020</h2>
                </div>
                <div className="portfolio__div3">
                    <h1 className="portfolio__line1">CRSA <span className="productPgae__span">Web</span></h1>
                </div>
                </div>
                <div className="portfolio__div5">
                    <div className="just"></div>
                    <img src={martin2} className="portfolio__img1"  />
                </div>
            </div>
            <div className="portfolio__div9">
                <div className="portfolio__div10">
                    <h3>Concept</h3>
                </div>
                <div className="portfolio__div11">
                    <motion.div ref={featuredRef} animate={animation} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0}}, hidden: {y: 70, opacity: 0}}} className="portfolio__div12">
                        <h1 className="portfolio__line">Martin Building Company is</h1>
                    </motion.div>
                    <motion.div ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2}}, hidden: {y: 70, opacity: 0}}}  className="portfolio__div13">
                        <h1 className="portfolio__line"> renowned for our commitment to</h1>
                    </motion.div>
                    <motion.div ref={featuredRef3} animate={animation3} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.3}}, hidden: {y: 70, opacity: 0}}}  className="portfolio__div14">
                        <h1 className="portfolio__line">quality design, historic and </h1>
                    </motion.div>
                    <motion.div ref={featuredRef4} animate={animation4} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4}}, hidden: {y: 70, opacity: 0}}}  className="portfolio__div15">
                        <h1 className="portfolio__line">preservation and neighbor-</h1>
                    </motion.div>
                    <motion.div ref={featuredRef5} animate={animation5} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.5}}, hidden: {y: 70, opacity: 0}}}  className="portfolio__div16">
                        <h1 className="portfolio__line"> We craft an intriguing</h1>
                    </motion.div>
                    <motion.div ref={featuredRef6} animate={animation6} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.7}}, hidden: {y: 50, opacity: 0}}}  className='portfolio__div17'>
                        <h1 className="portfolio__line">blend of stunning contemporary architecture</h1>
                    </motion.div>
                </div>
            </div>
            <div className="portfolio__div18">
                <div className="ortfolio__div19">
                    <motion.img whileHover={{scale: 1.2}} transition={transition} src={martin1} className="portfolio__img2" />
                </div>
            </div>
            <div className="portfolio__div20">
                <div className="portfolio__div21">
                    <motion.img src={martin3} whileHover={{scale: 1.2}} transition={transition} className="portfolio__img3" />
                </div>
            </div>
        </div>
        <div className="about__div24"><h3>Love it!! Take a Experience</h3></div>
        <Banner />
        <Footer />
        </>
    )
}

export default Portfolio;
